/**
 * @param {string} url
 * @returns {string|null}
 */
export function extractYouTubeId(url) {
  if (!url || typeof url !== 'string') return null
  const s = url.trim()
  if (!s) return null
  try {
    const base = s.startsWith('http') ? s : 'https://' + s
    const u = new URL(base)
    const h = u.hostname.replace(/^www\./, '')
    if (h === 'youtu.be') {
      const id = u.pathname.replace(/^\//, '').split('/')[0]
      return id || null
    }
    if (h.includes('youtube.com') || h === 'm.youtube.com') {
      if (u.pathname.startsWith('/shorts/')) {
        const id = u.pathname.split('/')[2]
        return id || null
      }
      const v = u.searchParams.get('v')
      if (v) return v
    }
  } catch (err) {
    return null
  }
  return null
}

/**
 * @param {string} videoId
 * @returns {string|null}
 */
export function youTubeEmbedUrl(videoId) {
  if (!videoId) return null
  return 'https://www.youtube-nocookie.com/embed/' + videoId
}
